import { init } from "i18next";

const enUS={
  app_info: "Application Information",
  previousEVCode: "Previous EV Code",
  eVCode: "EV Code",
  version: "Version",
  operationType: "Operation Type",
  xevmpdStatus: "xEVMPD Status",
  statusDate: "Status Date",
  fieldRequired: "{{field}} is required",
  add_app: "Add Application",
  actions: "Actions",
  app:"Application",
  application: "Applications",
  cancel: "Cancel",
  save: "Save",
  saveAndClose: "Save & Close",
  product:"Product",
  productFamily:"Product Family Name",
  recordId:"Record ID",
  administrableDoseForm:"Administrable Dose Form",
  internationalBirthDate:"International Birth Date",
  pharmaceuticalDoseForm:"Pharmaceutical Dose Form",
  combinedPharmaceuticalDoseForm:"Combined Pharmaceutical Dose Form",
  combinationPackage:"Combination Package",
  otsukaDemo:"Otsuka Demo",
  productName: "Product Name",
  productCategory: "Product Category",
  productPhase: "Product Phase",
  applicationType: "Application Type",
  procedureType: "Procedure Type",
  producerType: "Procedure Type",
  region: "Region",
  country: "Country",
  status: "Status",
  productType: "Product Type",
  edit_app: "Edit Application",
  edit: "Edit",
  view: "View",
  disable: "Disable",
  show_dis: "Show Disabled",
  show_active: "Show Active",
  show_inact: "Show Inactive",
  Status: "Status",
  Yes:"Yes",
  No:"No",
  "back":"Back",
  "finish":"Finish",
  "next":"Next",
  comments:"Comments",
 common: {
    "menu": "menu",
    "keywordSearch": "Type Keyword to Search",
    "actions": "Actions",
    "add": "Add",
    "edit": "Edit",
    "view": "View",
    "tag": "Tag",
    "collapseMenu": "Collapse Menu",
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "deleteConfirmMsg": "Are you sure you want to delete the record?",
    "no": "No",
    "yes": "Yes",
    "noDataAvailable": "No Data Available",
    "reason": "Reason",
    "createdBy": "Created By",
    "modifiedBy": "Modified By",
    "saveChanges": "Save Changes",
    "close": "Close",
    "pleaseEnter": "Please Enter...",
    "globalSmartSearch": "Global Search...",
    "loadingText": "We are loading the data for you. Please wait.",
    "collapse": "Collapse",
    "expand": "Expand",
    "search": 'Search',
    "paracetamol": 'paracetamol',
    "disable": 'Disable',
    "saveAndNext": 'Save & Next',
    "inactive": 'Inactive',
    "user": 'User',
    "downloadPDF": 'Download as PDF',
    "downloadExcel": 'Download as Excel',
    "downloadCSV": 'Download as CSV',
    "typeofAssociation": "Type of Association",
    "recordName": "Record Name",
    "entityIdentifier" : "Entity Identifier",
    "entityName" : "Entity Name",
    "auditIdentifier" : "Audit Identifier",
    "operationType" : "Operation Type",
    "operationDate" : "Operation Date and Time",
    "entityCreatedByName" : "Created By",
    "entityCreatedDate" : "Created Date and Time",
    "entityModifiedDate" : "Modified Date and Time",
    "fieldName" : "Field Name",
    "beforeModification" : "Before Modification",
    "afterModification" : "After Modification",
        "auditNoteMessage":"Note: This table only contains the fields which were updated during this transaction",
        "Created By": "Created By",
        "Created Date": "Created Date",
        Disabled: "Disabled",
        "Modified By": "Modified By",
        "Modified Date": "Modified Date",
    "updatedBy": "Updated By",
    "updatedDate": "Updated Date",
    lastModifiedBy: "Last Modified By",
    Identifier: "Identifier",
    "Group Id": "Group Id",
    linkRecord:"Linked Records",
    tip: {
      addSuccess: "Add successfully.",
      addFailed: "Add failed.",
      updateSuccess: "Update successfully.",
      updateFailed: "Update failed.",
      revertSuccess: "Revert successfully.",
      revertFailed: "Revert failed.",
      deleteSuccess: "Delete successfully.",
      deleteFailed: "Delete failed.",
      deletion: "Please enter a reason for deletion.",
      limit_2000: "The input exceeds the maximum limit of 2,000 characters.",
      selectOneItem: "Please select one item.",
      selectTarget: "Please select target first.",
    },
        userOnDate:'{{user}} on {{date}}'

  },

  sideMenuData: {
    Authorisation:{
  eVCode: "EV Code",
  authorizationCountryCode: "Authorisation Country Code (AP.12.1)",
  procedureType: "Authorisation Procedure (AP.12.2)",
  authorizationStatus: "Authorisation Status (AP.12.3)",
  authorizationNumber: "Authorisation Number (AP.12.4)",
  authorizationRenewalDate: "Authorisation Renewal Date (AP.12.5)",
  "mRP/DCP/EMEAnumber": "MRP/DCP/EMEA number (AP.12.7)",
  eUNumber: "EU Number (AP.12.8)",
  orphanDrug: "Orphan Drug Status (AP.12.9)",
  additionalMonitoringIndicator: "Additional Monitoring (AP.12.10)",
  legalBasis: "Legal Basis (AP.12.13)", 
  xEVMPD: "Comments (AP.14)",
  infoDate: "Info Date (AP.11)",
  invalidateDate: "Invalidate Date (AP.12.12)",
  medicinalProductType: "Medicinal Product Types (AP.12.MPT.1)",
  previousEVCode: "Previous EV Code (AP.PEV.1)",
    },
    MAH:{
   eVCode: "EV Code",
  mAHCode: "MAH Code (AP.4)",
  authorizationHolderName: "MAH Name",
  address: "Address",
  city: "City",
  postalCode: "Postal Code",
  countryCode: "Country Code",
    },

    "Presentation Details":{
   eVCode: "EV Code",
  fullName: "Full Presentation Name (AP.13.1)",
  inventedNamePart: "Product Short Name (AP.13.2)",
  scientificNamePart: "Product INN/Common Name (AP.13.3)",
  trademarkOrCompanyNamePart: "Product Company Name (AP.13.4)",
  strengthPart: "Product Strength Name (AP.13.5)",
  pharmaceuticalDoseFormPart: "Product Form Name (AP.13.6)",
  description: "Package Description (AP.13.7)",
    },
  
   "ATC Code(s)":{ 
    eVCode: "EV Code",
  aTCCode: "Product ATC Code (AP.ATC.1)",
   },

   "Product Indication":{
    eVCode: "EV Code",
  MedDRAVersion: "MedDRA Version (AP.IND.1)",
  MedDRALevel: "MedDRA Level (AP.IND.2)",
  MedDRACode: "MedDRA Code (AP.IND.3)",
  MedDRATerm: "MedDRA Term (AP.IND.3)",
   },

   "Pharmacovigilance":{
  eVCode: "EV Code",
  qppvIdentifiers: "Qualified Person Responsible for Pharmacovigilance (QPPV) Code (AP.5)",
  psmfLocationCode: "Pharamcovigilance System Master File Location (PSMFL) Code (AP.6)",
  enquiryInformationEmailAddress: "Pharmacovigilance Enquiry Email (AP.7)",
  enquiryInformationPhoneNumber: "Pharmacovigilance Enquiry Phone (AP.8)",
   }
,
  "Pharmaceutical Product":{
  pharmaceuticalDoseForm: "Pharmaceutical Form",
  administrableDoseForm: "Administrable Pharmaceutical Form",
  route: "Administration Route (PP.AR.1)",
  ingredientName: "Substance Name",
  substanceCode: "Substance Code",
  ingredientRole: "Role of Ingredient",
  CompositionCategory_CMCY1_quantityOperator: "Amount Value Type",
  singleLowLimitNumeratorValue: "Low Amount Numerator Value",
  lowAmountNumeratorPrefix: "Low Amount Numerator Prefix",
  StrengthType_ST1_singleLowLimitNumeratorValueUnit: "Low Amount Numerator Unit",
  singleLowLimitDenominatorValue: "Low Amount Denominator Value",
  lowAmountDenominatorPrefix: "Low Amount Denominator Prefix",
  StrengthType_ST1_singleLowLimitDenominatorValueUnit: "Low Amount Denominator Unit",
  medicaldeviceCode: "Medical device Code (PP.MD.1)",
  highLimitNumeratorValue : "High Amount Numerator Value",
highLimitNumeratorPrefix : "High Amount Numerator Prefix",			
StrengthType_ST1_highLimitNumeratorValueUnit : "High Amount Numerator Unit",	
highLimitDenominatorValue: "High Amount Denominator Value",
highAmountDenominatorPrefix : "High Amount Denominator Prefix",			
StrengthType_ST1_highLimitDenominatorValueUnit : "High Amount Denominator Unit",

  }
,
Attachments:{
  eVCode: "EV Code",
  fullName: "File Name (ATT.2)",
  documentType: "File Type (ATT.3)",
  attachmentType: "Attachment Type (ATT.5)",
  languageCode: "Language Code (ATT.6)",
  attachmentValidityDeclaration: "Attachment Validity Declaration (AP.PPI.2)",
  fullVersion: "Attachment Version (ATT.8)",
  attachmentVersionDate: "Attachment Version Date (ATT.9)",
  attachmentEVCode: "Attachment EV Code (AP.PPI.1)",
  directory: "Attachment Name (ATT.4)",
}
 
  

},
disableProductTitle: "Are you sure you want to delete the record?",
  reasonForDisable: "Reason for Delete",
  disableProductSuccessTip: "Deleted the record successfully.",
  reasonToDisable:"Reason For Delete",
  commentsOnDisable:"Comments on Delete",
   acknowledgements:"Acknowledgements",
   acknowledgementsType:"Acknowledgements Type",
   ackComments:"Comments",
   ackStatusDate:"Status Date",
   attachment:"Attachment",
   attachmentName:"Attachment Name",
   "noDataUpdatedMessage": "No data updated. Click 'Cancel' to return.",
   confirmNavigation:"Confirm Navigation",
   navigationWarning:"Any changes made to the xEVMPD data will be lost. Do you wish to continue?",
   fileName:"File Name",
   processComments:"Process Comments",
   eSignature:"E-Signature",
workflow:{
  workflowLabel:'Workflow',
  associateProcess:'Associate Process',
  initiateProcess:'Initiate Process',
  viewProcess:'View Process',
  terminateProcess:'Terminate Process',
  end:'End',
  endProcess:'End Process',
  Completed:'Complete Task',
  task:"Task",
  instructions:"Instructions",
  Rejected:'Send Back to Author',
  completeTask:'Complete Task',
  rejectTask:'Reject Task',
  complete:'Complete',
  reject:'Reject',
  recallTask:'Recall Task',
  recall:'Recall',
  associatedSuccessfully:'Process associated successfully',
  initiatedSuccessfully:'Process initiated successfully',
  nextStepSuccessfully:'Task completed successfully',
  recallStepSuccessfully:'Task recalled successfully',
  rejectStepSuccessfully:'{{action}} successfully',
  terminateProcessSuccessfully:'Process ended successfully',
  processEndFailed:'Failed to end process',
  needTerminateFirst:'A process is already associated with this product. Would you like to end it and re-associate?',
  enterCommentsForEndProcess:'Enter Comments for End Process',
  viewProcessApplication : "View Application",
  editProcessApplication : "Edit Application",
  commonErrorMessage : "Not able to process the action.",
},

bpmn:{processBar:{processStatus:"Process Status"}},
 identifiers: {
    title: "Manage Identifiers",
    updateSuccessTip: "Identifiers Updated Successfully!",
    updateSuccessTipWithNumber:
      "{{successCount}} out of {{allCount}} record(s) updated successfully!",
    saveSuccess: "Identifiers saved successfully",
    saveError: "Error in Saving Identifiers",
    manageIdentifier: "Manage Identifiers",
    bulkActions: "Bulk Actions"
  }
};

export default enUS;